export const bookingDurations = ["1", "2", "3", "4", "5", "day"] as const;

export type BookingDuration = (typeof bookingDurations)[number];

export const bookingDurationLabels: Record<BookingDuration, string> = {
  "1": "1 Stunde",
  "2": "2 Stunden",
  "3": "3 Stunden",
  "4": "4 Stunden",
  "5": "5 Stunden",
  day: "den gesamten restlichen Tag",
};

/**
 * Same slots, different day semantics: camping bookings end at midnight ("den
 * gesamten restlichen Tag"), while tariff billing charges a daily rate per
 * rolling 24 hours starting at pickup.
 */
export const tariffDurationLabels: Record<BookingDuration, string> = {
  "1": "1 Stunde",
  "2": "2 Stunden",
  "3": "3 Stunden",
  "4": "4 Stunden",
  "5": "5 Stunden",
  day: "bis 24 Stunden",
};

export function parseBookingDuration(
  value: string | undefined | null,
): BookingDuration | undefined {
  if (!value) {
    return undefined;
  }
  return (bookingDurations as readonly string[]).includes(value)
    ? (value as BookingDuration)
    : undefined;
}
